export default __webpack_public_path__ + "static/gold-670e2e31f6d1fa02fb616b2be21f281c.jpg";